'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

const MarkdownView = dynamic(() => import('@/components/ui/markdown-view/markdown-view').then((mod) => mod.MarkdownView), { ssr: false })

export interface SPVideoTextSectionProps {
  content: string
}

const SPVideoTextSection: FC<SPVideoTextSectionProps> = ({ content }) => {
  return (
    <div className="sp-detail-section">
      <div className="sp-detail-section-label">動画テキスト</div>
      <MarkdownView content={content} />
    </div>
  )
}

export default SPVideoTextSection
